import React from "react";
import {
  tooltipButtons,
  tooltipChecklistContent,
  tooltipChecklistContentNeGD
} from "../../../NewConstants/TooltipConstants";
import { isNeGDDeployment } from "../../../Actions/Utils";

const TooltipChecklist = ({
  selectedLanguage,
  setShowTooltipChecklist,
  setStartTour,
}) => {
  const isNeGD = isNeGDDeployment();
  const neGDBackground = isNeGD
    ? { backgroundImage: "url(/Assets/Images/NavBackground.svg)" }
    : {};

  return (
    <div className="fixed inset-0 z-[1000] flex flex-col">
      <div
        className={`w-full h-[3.75rem] flex items-center justify-between px-4 ${isNeGD ? "" : "bg-white"}`}
        style={neGDBackground}
      >
        <button
          className="flex items-center gap-2 font-semibold text-lg focus:outline-none"
          style={{ color: isNeGD ? "white" : "black" }}
          onClick={() => setShowTooltipChecklist(false)}
          aria-label="Back to chat"
        >
          <img
            src={isNeGD ? "/Assets/Images/previousWhiteIcon.svg" : "/Assets/Images/arrowLeftBlack.svg"}
            alt="Back Arrow"
            className="w-6 h-6"
          />
          {tooltipButtons.backToChat[selectedLanguage] || tooltipButtons.backToChat.en}
        </button>
      </div>

      <div
        className="flex-1 w-full flex flex-col items-center justify-start px-4 py-6 overflow-y-auto"
        style={{ backgroundImage: `url("/Assets/Images/bgWallpaper.svg")` }}
      >
        <div className="w-full max-w-[22rem] bg-white rounded-2xl shadow-md flex flex-col items-center px-4 pt-3 pb-5">

          <img
            src="/Assets/Images/Tooltip/TooltipCheckList/tooltip_lady.svg"
            alt="Learn illustration"
            className="w-full object-contain rounded-lg"
          />

          <div className="w-full text-center my-5 px-2">
            <p className="font-bold text-[1.25rem] leading-tight text-[var(--primary-dark-1)]">
              {isNeGD ? tooltipChecklistContentNeGD[selectedLanguage] || tooltipChecklistContentNeGD.en : tooltipChecklistContent[selectedLanguage] || tooltipChecklistContent.en}
            </p>
          </div>

          <button
            className="w-full h-[3.375rem] rounded-[1rem] bg-[var(--primary-dark)] text-white shadow-sm flex items-center justify-center gap-3"
            aria-label="Start tour"
            onClick={() => {
              setStartTour(true);
              setShowTooltipChecklist(false);
            }}
            style={neGDBackground}
          >
            <span className="text-[16px] font-semibold">
              {tooltipButtons.TooltipStart[selectedLanguage] ||
                tooltipButtons.TooltipStart.en}
            </span>
            <img
              src="/Assets/Images/Tooltip/TooltipCheckList/PlayPause.svg"
              alt="play pause"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TooltipChecklist;
